import { render, staticRenderFns } from "./_BusinessUnitWrapper.vue?vue&type=template&id=1f33ae41&scoped=true&"
import script from "./_BusinessUnitWrapper.vue?vue&type=script&lang=js&"
export * from "./_BusinessUnitWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f33ae41",
  null
  
)

export default component.exports